import { render, staticRenderFns } from "./SideBarGuide.vue?vue&type=template&id=282ae744&"
import script from "./SideBarGuide.vue?vue&type=script&lang=js&"
export * from "./SideBarGuide.vue?vue&type=script&lang=js&"
import style0 from "./SideBarGuide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports